<template>
  <b-modal
    ref="priorityModal"
    size="xs"
    centered
    modal-class="priority-modal"
    @hidden="hide"
  >
    <div slot="modal-title">
      {{ actionTitle }} <span style="text-transform: lowercase">{{ $tc('configuration.sections.priorities', 1) }}</span>
    </div>
    <b-row class="pt-2 pb-3 px-3">
      <b-col cols="5">
        <div class="form-label">
          <label>{{ $t('configuration.grid.externalCode') }}</label>
        </div>
        <vt-input
          ref="code"
          v-model="internalPriority.code"
          class="form-control-sm"
        />
      </b-col>
      <b-col cols="4">
        <div class="form-label d-flex align-items-center">
          <label>{{ $t('configuration.grid.level') }}</label>
          <button
            id="help-priority"
            class="btn btn__icon btn__icon--primary btn-secondary mr-0 py-0 pr-0"
          >
            <i
              class="far fa-question-circle"
              aria-hidden="true"
            />
          </button>
          <b-popover
            :target="'help-priority'"
            triggers="click blur"
            placement="bottomleft"
          >
            <div class="p-2">
              {{ $t('configuration.modal.help.priorityLevel') }}
            </div>
          </b-popover>
        </div>
        <vt-input
          ref="code"
          v-model="internalPriority.level"
          type="number"
          class="form-control-sm"
        />
      </b-col>
      <b-col cols="3">
        <div class="form-label">
          <label>{{ $t('configuration.grid.color') }}</label>
        </div>
        <vt-input
          v-model="internalPriority.color"
          type="color"
          class="form-control-sm"
        />
      </b-col>
      <b-col
        cols="12"
        class="mt-3"
      >
        <div class="form-label">
          <label>{{ $tc('configuration.sections.priorities', 1) }}</label>
        </div>
        <ConfigurationNameTranslations :name-translations="internalPriority.nameTranslations" />
      </b-col>
      <b-col
        cols="12"
        class="mt-3 d-flex justify-content-end"
      >
        <div class="switch-btn mt-1 p-0 d-flex align-items-center">
          <span
            v-if="internalPriority.active"
            class="mr-2"
          >{{ $t('configuration.actions.active') }}</span>
          <span
            v-else
            class="mr-2"
          >{{ $t('configuration.actions.inactive') }}</span>
          <input
            id="toggle"
            v-model="internalPriority.active"
            type="checkbox"
            class="offscreen"
            aria-hidden="true"
          >
          <label
            for="toggle"
            class="switch mb-0"
          />
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            :disabled="!internalPriority.code || !internalPriority.nameTranslations.length"
            size="sm"
            class="btn--primary"
            @click="update()"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ actionTitle }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ConfigurationNameTranslations from '@/modules/configurationModule/detail/ConfigurationNameTranslations'
import languageService from '@/api/resources/common/languageService'
import { cloneDeep, isEmpty, uniqBy } from 'lodash'

export default {
    name: 'PriorityModal',
    components: {
        ConfigurationNameTranslations
    },
    props: {
        actionTitle: String
    },
    data() {
        return {
            internalPriority: {}
        }
    },
    methods: {
        async show(selectedPriority) {
            let allNameTranslations = []
            this.updateLoading(true)
            const [err, response] = await this.toCall(languageService.findAllActiveAndUiEnabled())
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            const activeUILanguages = response
            if (selectedPriority && !isEmpty(selectedPriority)) {
                this.internalPriority = cloneDeep(selectedPriority)
            } else {
                this.clearData()
            }
            const defaultNameTranslations = activeUILanguages.map(lang => {
                return {
                    language: lang,
                    notes: '',
                    value: ''
                }
            })
            allNameTranslations = uniqBy(this.internalPriority.nameTranslations.concat(defaultNameTranslations), 'language.id')
            this.internalPriority.nameTranslations = allNameTranslations
            this.$refs.priorityModal.show()
            this.$nextTick(() => {
                this.$refs.code.focus()
            })
        },
        hide() {
            this.$refs.priorityModal.hide()
        },
        update() {
            if (this.internalPriority.id) this.$emit('update', this.internalPriority)
            else this.$emit('create', this.internalPriority)
        },
        clearData() {
            this.internalPriority = {
                active: true,
                code: '',
                color: '',
                level: 0,
                name: '',
                nameTranslations: []
            }
        }
    }
}
</script>

<style lang="scss">
    .priority-modal .translations-area {
        max-height: 100px;
        overflow-y: auto;
        padding-bottom: 3px;
    }
</style>
